import { r as registerInstance, c as createEvent, h, H as Host, g as getElement } from './index-662ec80e.js';
import { p as propCheck, r as runWatchers } from './propCheck-e7571e3e.js';
import { Q as vBoolean } from './validation-02b8d01d.js';
import './i18n-939e2dee.js';

const dsDialogCss = "ds-dialog{display:-ms-flexbox;display:flex;z-index:9998;position:fixed;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;width:100vw;height:100vh;top:0;bottom:0;left:0;right:0;transition:opacity 0.4s;overflow:auto;background:transparent;-ms-flex-line-pack:start;align-content:flex-start;padding-top:calc(var(--gw) * 4)}ds-dialog[is-modal]{background-color:rgba(10, 10, 40, 0.8)}ds-dialog:not([is-open]){display:none}ds-dialog .dialog__container{z-index:9999;margin:0 auto;background-color:var(--white);width:fit-content;height:fit-content;padding:calc(var(--gw) * 1.5);border-radius:var(--border-radius);position:relative;box-shadow:var(--shadow-2)}ds-dialog .dialog--close{position:absolute;right:0;top:0;cursor:pointer;padding:0.75rem}";

const DsDialog = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.closed = createEvent(this, "closed", 7);
    this.displayError = false;
    this.propError = {};
    this.isModal = false;
    this.isDismissible = true;
    this.isOpen = false;
  }
  watchIsModal() {
    /* istanbul ignore if */
    if (!propCheck(this, 'isModal', 'boolean', vBoolean))
      return;
  }
  watchIsDismissible() {
    /* istanbul ignore if */
    if (!propCheck(this, 'isDismissible', 'boolean', vBoolean))
      return;
  }
  async open() {
    this.isOpen = true;
    this.previousOverflowY = document.body.style.overflowY;
    document.body.style.overflowY = 'hidden';
  }
  async close() {
    this.isOpen = false;
    document.body.style.overflowY = this.previousOverflowY;
    this.closed.emit();
  }
  keyupListener(e) {
    if (this.isOpen && this.isDismissible && e.key === 'Escape')
      this.close();
  }
  connectedCallback() {
    runWatchers(this);
  }
  disconnectedCallback() {
    // handle unexpected remove while open
    if (this.isOpen) {
      document.body.style.overflowY = this.previousOverflowY;
    }
  }
  render() {
    // Because reflected props are auto-casted, boolean prop validation is always valid
    // if (hasPropError(this)) return displayPropError(this);
    return (h(Host, { "is-open": this.isOpen, onClick: (e) => this.isDismissible && e.target === this.hostElement && this.close() }, h("div", { class: "dialog__container" }, this.isDismissible ? (h("ds-icon", { name: "close", color: "var(--grey-900)", size: "0.75rem", class: "dialog--close", onClick: () => this.close() })) : null, h("slot", null))));
  }
  get hostElement() { return getElement(this); }
  static get watchers() { return {
    "isModal": ["watchIsModal"],
    "isDismissible": ["watchIsDismissible"]
  }; }
};
DsDialog.style = dsDialogCss;

export { DsDialog as ds_dialog };
